import { FormArray, FormGroup } from '@angular/forms';
import { FormControlsOf } from '@y42/angular/forms';
import {
  ColumnTypeEnum,
  OperationModel,
  OperatorEnum,
  OperatorTypeEnum,
  OperatorValueTypeEnum,
} from '@y42/json-schema';

export interface OperationInputColumn {
  field_name: string;
  description: string | null;
  data_type: ColumnTypeEnum;
}

export interface OperatorModel {
  value: OperatorEnum;
  text: string;
}

export interface OperatorTypeModel {
  value: OperatorTypeEnum;
  text: string;
}
export interface OperatorValueTypeModel {
  value: OperatorValueTypeEnum;
  text: string;
}

export interface OperationInputForm {
  operations: FormArray<FormGroup<OperatorForm>>;
}

export type OperatorForm = FormControlsOf<OperationModel>;

export function getDefaultOperatorForColumnType(type: ColumnTypeEnum | null): OperatorEnum {
  switch (type) {
    case ColumnTypeEnum.Numeric:
      return OperatorEnum.Equals;
    case ColumnTypeEnum.String:
      return OperatorEnum.Equals;
    case ColumnTypeEnum.Date:
      return OperatorEnum.Between;
    case ColumnTypeEnum.Datetime:
      return OperatorEnum.Between;
    case ColumnTypeEnum.Timestamp:
      return OperatorEnum.Between;
    case ColumnTypeEnum.Boolean:
      return OperatorEnum.Equals;
    default:
      return OperatorEnum.Equals;
  }
}

export enum OperationInputType {
  Boolean = 'boolean',
  Date = 'date',
  Number = 'number',
  Text = 'text',
}

export const OperationInputTypeToColumnTypes: Record<OperationInputType, ColumnTypeEnum[]> = {
  [OperationInputType.Boolean]: [ColumnTypeEnum.Boolean],
  [OperationInputType.Date]: [ColumnTypeEnum.Date, ColumnTypeEnum.Datetime, ColumnTypeEnum.Timestamp],
  [OperationInputType.Number]: [ColumnTypeEnum.Numeric, ColumnTypeEnum.Integer, ColumnTypeEnum.Float],
  [OperationInputType.Text]: [ColumnTypeEnum.String, ColumnTypeEnum.ArrayString, ColumnTypeEnum.Geo],
};

export const DATE_TIME_COLUMN_TYPES: ColumnTypeEnum[] = [
  ColumnTypeEnum.Date,
  ColumnTypeEnum.Datetime,
  ColumnTypeEnum.Timestamp,
];

export interface AbsoluteDateRangePreset {
  label: string;
  start: Date;
  end: Date;
}

export interface RelativeDateRangePreset {
  label: string;
  valueType: OperatorValueTypeEnum;
  from: number;
  to: number;
}
